export default async ({ dispatch, state }, event) => {
  console.log('handlers/tasklists', event);
  const { actionType, itemId } = event;
  if (['updated'].includes(actionType)) {
    const pid = itemId || state.project.currentProjectId;
    await dispatch('project/tasklists/changeNotification', pid);
  }
};
